export const recentQuotesTableColumns = [
  { header: "Quote Reference", accessor: "reference", editable: false },
  { header: "Customer", accessor: "customer", editable: false },
  { header: "Site", accessor: "site", editable: false },
  { header: "Amount", accessor: "amount", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const recentInvoicesTableColumns = [
  { header: "Invoice Reference", accessor: "reference", editable: false },
  { header: "Customer", accessor: "customer", editable: false },
  { header: "Site", accessor: "site", editable: false },
  { header: "Amount", accessor: "amount", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const recentMovementsTableColumns = [
  { header: "Activity Type", accessor: "activityType", editable: false },
  { header: "Activity SubType", accessor: "activitySubType", editable: false },
  { header: "Source", accessor: "source", editable: false },
  { header: "Destination", accessor: "destination", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const inventoryTableColumns = [
  { header: "Item Code", accessor: "itemCode", editable: true },
  { header: "Description", accessor: "description", editable: true },
  { header: "Unit Weight (KG)", accessor: "unitWeight", editable: true },
  { header: "Length", accessor: "length", editable: true, editor: "text" as const },
  { header: "Unit Value", accessor: "value", editable: true, format: "number" as const },
  { header: "Hire Rate / Week", accessor: "hireRatePerWeek", editable: true, format: "number" as const },
  { header: "Available", accessor: "availableQuantity", editable: true, format: "number" as const },
  { header: "Rented", accessor: "rentedQuantity", editable: true, format: "number" as const },
  { header: "Reserved", accessor: "reservedQuantity", editable: true, format: "number" as const },
  { header: "Damaged", accessor: "damagedQuantity", editable: true, format: "number" as const },
  { header: "Lost", accessor: "lostQuantity", editable: true, format: "number" as const },
  { header: "Sold", accessor: "soldQuantity", editable: true, format: "number" as const },
  { header: "Total", accessor: "totalQuantity", editable: false, format: "number" as const },
  { header: "Total Value", accessor: "totalValue", editable: false, format: "number" as const },
  { header: "Warehouse", accessor: "warehouse.name", editable: false },
];

export const siteInventoryTableColumns = [
  { header: "Item Code", accessor: "item_code", editable: false },
  { header: "Description", accessor: "description", editable: false },
  { header: "Unit Weight (KG)", accessor: "unit_weight", editable: false },
  { header: "Total Quantity", accessor: "quantity", editable: false },
  { header: "Good Quantity", accessor: "available", editable: false },
  { header: "Damaged Quantity", accessor: "damaged", editable: false },
  { header: "Total Weight", accessor: "total_weight", editable: false },
];

export const invoicesTableColumns = [
  { header: "Invoice #", accessor: "reference", editable: false },
  { header: "Customer", accessor: "customer", editable: false },
  { header: "Site", accessor: "site", editable: false },
  { header: "Issue Date", accessor: "issueDate", editable: false },
  { header: "Due Date", accessor: "dueDate", editable: false },
  { header: "Amount", accessor: "amount", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const quotesTableColumns = [
  { header: "Quote #", accessor: "reference", editable: false },
  { header: "Customer", accessor: "customer", editable: false },
  { header: "Site", accessor: "site", editable: false },
  { header: "Amount", accessor: "amount", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const deliveriesTableColumns = [
  { header: "Date", accessor: "date", editable: false },
  { header: "Site", accessor: "site", editable: false },
  { header: "Item", accessor: "item", editable: false },
  { header: "Quantity", accessor: "quantity", editable: false },
  { header: "Driver", accessor: "driver", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const usersTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Email", accessor: "email", editable: false },
  { header: "Phone", accessor: "phone", editable: false },
  { header: "Location", accessor: "location", editable: false },
  { header: "Role", accessor: "role", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const customersTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Type", accessor: "type", editable: false },
  { header: "Address", accessor: "address", editable: false },
  { header: "Country", accessor: "country", editable: false },
  { header: "Phone Number", accessor: "phone_number", editable: false },
  { header: "Point of Contact", accessor: "point_of_contact", editable: false },
  { header: "TIN", accessor: "tin", editable: false },
  { header: "VRN", accessor: "vrn", editable: false }
];

export const sitesTableColumns = [
  { header: "Site Name", accessor: "site_name", editable: false },
  { header: "Customer Name", accessor: "customer_name", editable: false },
  { header: "Customer Phone", accessor: "customer_phone", editable: false },
  { header: "Location", accessor: "location", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const activitiesTableColumns = [
  { header: "Reference", accessor: "reference", editable: false },
  { header: "Date", accessor: "date", editable: false },
  { header: "Initiator", accessor: "initiator", editable: false },
  { header: "Source", accessor: "source", editable: false },
  { header: "Destination", accessor: "destination", editable: false },
  { header: "Activity Type", accessor: "activity_type", editable: false },
  { header: "Activity Sub Type", accessor: "activity_sub_type", editable: false },
  { header: "Project Type", accessor: "project_type", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const warehousesTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Location", accessor: "location", editable: false },
  { header: "Point of Contact", accessor: "point_of_contact", editable: false },
  {
    header: "Available (Weight)",
    accessor: "available_weight",
    editable: false,
  },
  { header: "Rented (Weight)", accessor: "rented_weight", editable: false },
  { header: "Damaged (Weight)", accessor: "damaged_weight", editable: false },
  { header: "Reserved (Weight)", accessor: "reserved_weight", editable: false },
  { header: "Lost (Weight)", accessor: "lost_weight", editable: false },
  { header: "Sold (Weight)", accessor: "sold_weight", editable: false },
  { header: "Total (Weight)", accessor: "Total_weight", editable: false },
  { header: "Total Value", accessor: "total_value", editable: false },
  { header: "Status", accessor: "status", editable: false },
];

export const ppeStockTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Size", accessor: "size", editable: false },
  { header: "Condition", accessor: "condition", editable: false },
  { header: "Quantity", accessor: "quantity", editable: false },
  { header: "Unit", accessor: "unit", editable: false },
  { header: "Warehouse", accessor: "warehouse_name", editable: false },
  { header: "Updated At", accessor: "updated_at", editable: false },
];

export const ppeUsersTableColumns = [
  { header: "Full Name", accessor: "full_name", editable: false },
  { header: "Job Title", accessor: "job_title", editable: false },
  { header: "Location", accessor: "location", editable: false },
  { header: "Updated At", accessor: "updated_at", editable: false },
];

export const ppeProvisionsTableColumns = [
  { header: "Date Issued", accessor: "provided_date", editable: false },
  { header: "PPE/Non Scaffolds User", accessor: "ppe_user", editable: false },
  { header: "Job Title", accessor: "job_title", editable: false },
  { header: "Location", accessor: "location", editable: false },
  { header: "PPE/Non Scaffolds", accessor: "ppe_name", editable: false },
  { header: "Quantity", accessor: "quantity", editable: false },
  { header: "Unit", accessor: "unit", editable: false },
  { header: "Provided By", accessor: "provided_by", editable: false },
  { header: "Documents", accessor: "documents_count", editable: false },
];

export const ppeUserProvisionsTableColumns = [
  { header: "Date Issued", accessor: "provided_date", editable: false },
  { header: "PPE/Non Scaffolds", accessor: "ppe_name", editable: false },
  { header: "Quantity", accessor: "quantity", editable: false },
  { header: "Unit", accessor: "unit", editable: false },
  { header: "Provided By", accessor: "provided_by", editable: false },
];

export const ppePurchasesTableColumns = [
  { header: "Date Purchased", accessor: "purchased_date", editable: false },
  { header: "PPE/Non Scaffolds", accessor: "ppe_name", editable: false },
  { header: "Quantity", accessor: "quantity", editable: false },
  { header: "Unit", accessor: "unit", editable: false },
  { header: "Warehouse", accessor: "warehouse_name", editable: false },
  { header: "Notes", accessor: "notes", editable: false },
  { header: "Recorded By", accessor: "purchased_by", editable: false },
  { header: "Documents", accessor: "documents_count", editable: false },
];

export const bankDetailsTableColumns = [
  { header: "Bank Name", accessor: "bankName", editable: false },
  { header: "Account Name", accessor: "accountName", editable: false },
  { header: "Account Number", accessor: "accountNumber", editable: false },
  { header: "SWIFT Code", accessor: "swiftCode", editable: false },
  { header: "Branch", accessor: "branchName", editable: false },
];

export const vendorsTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Phone Number", accessor: "phone_number", editable: false },
  { header: "Email", accessor: "email", editable: false },
  { header: "Address", accessor: "address", editable: false },
  { header: "Country", accessor: "country", editable: false },
];

export const fixedAssetsTableColumns = [
  { header: "Description", accessor: "description", editable: false },
  { header: "Division", accessor: "division", editable: false },
  { header: "Serial", accessor: "serial_number", editable: false },
  { header: "Units", accessor: "units", editable: false },
  { header: "Rate (p.a.)", accessor: "depreciation_rate", editable: false },
  { header: "Cost", accessor: "cost_price", editable: false },
  { header: "Purchased", accessor: "date_purchased", editable: false },
];

export const reportCurrencyTableColumns = [
  { header: "Currency", accessor: "currency", editable: false },
  { header: "Quotations", accessor: "quotations", editable: false },
  { header: "Invoices", accessor: "invoices", editable: false },
  { header: "Invoice Total", accessor: "invoiceTotal", editable: false },
];

export const shopCategoriesTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Sort", accessor: "sort_order", editable: false },
  { header: "Enabled", accessor: "enabled", editable: false },
  { header: "Created", accessor: "created_at", editable: false },
];

export const shopProductsTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Category", accessor: "category", editable: false },
  { header: "Purchase Price", accessor: "purchase_price", editable: false },
  { header: "Offer Price", accessor: "offer_price", editable: false },
  { header: "Images", accessor: "image_count", editable: false },
  { header: "Videos", accessor: "video_count", editable: false },
  { header: "Enabled", accessor: "enabled", editable: false },
];

export const shopOrdersTableColumns = [
  { header: "Reference", accessor: "reference", editable: false },
  { header: "Customer", accessor: "customer", editable: false },
  { header: "Location", accessor: "location", editable: false },
  { header: "Items", accessor: "item_count", editable: false },
  { header: "Attachments", accessor: "attachment_count", editable: false },
  { header: "Status", accessor: "status", editable: false },
  { header: "Created", accessor: "created_at", editable: false },
];

export const productOrderItemsTableColumns = [
  { header: "Product", accessor: "product", editable: false },
  { header: "Type", accessor: "order_type", editable: false },
  { header: "Qty", accessor: "quantity", editable: false },
  { header: "Days hired", accessor: "days_hired", editable: false },
  { header: "Unit Price", accessor: "unit_price", editable: false },
  { header: "Line Total", accessor: "line_total", editable: false },
];

export const siteServiceTypesTableColumns = [
  { header: "Image", accessor: "icon_url", editable: false },
  { header: "Name", accessor: "name", editable: false },
  { header: "Status", accessor: "status", editable: false },
  { header: "Created", accessor: "created_at", editable: false },
];

export const siteServiceRequestsTableColumns = [
  { header: "Reference", accessor: "reference", editable: false },
  { header: "Service", accessor: "service_type", editable: false },
  { header: "Customer", accessor: "customer", editable: false },
  { header: "Attachments", accessor: "attachment_count", editable: false },
  { header: "Created", accessor: "created_at", editable: false },
];

export const overdueSiteRemindersTableColumns = [
  { header: "Site / customer", accessor: "site_customer", editable: false },
  { header: "Overdue since", accessor: "overdue_since", editable: false },
  { header: "Remarks", accessor: "remark_count", editable: false },
];

export const attachmentTypesTableColumns = [
  { header: "Name", accessor: "name", editable: false },
  { header: "Context", accessor: "context", editable: false },
  { header: "Extensions", accessor: "allowed_extensions", editable: false },
  { header: "Max size (MB)", accessor: "max_file_size", editable: false },
  { header: "Max files", accessor: "max_files", editable: false },
  { header: "Sort", accessor: "sort_order", editable: false },
  { header: "Enabled", accessor: "enabled", editable: false },
];

export const reportCustomersTableColumns = [
  { header: "Customer", accessor: "customerName", editable: false },
  { header: "Type", accessor: "type", editable: false },
  { header: "Sites", accessor: "sites", editable: false },
  { header: "Quotations", accessor: "quotations", editable: false },
  { header: "Invoices", accessor: "invoices", editable: false },
  { header: "Invoice Total", accessor: "invoiceTotal", editable: false },
  { header: "Paid", accessor: "paid", editable: false },
  { header: "Unpaid", accessor: "unpaid", editable: false },
];
